var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "rounded-lg", attrs: { id: "recordings" } },
    [
      _c("v-card-title", [_vm._v(" Recordings ")]),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _vm.recordings.length
            ? _c("v-simple-table", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function () {
                        return [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Timestamp")]),
                              _c("th", [_vm._v("Room")]),
                              _c("th"),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.recordings, function (recording) {
                              return _c("tr", { key: recording.ID }, [
                                _c(
                                  "td",
                                  { staticStyle: { "white-space": "nowrap" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.formatRecordingDate(recording))
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { "white-space": "nowrap" } },
                                  [_vm._v(_vm._s(recording.post_title))]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { "white-space": "nowrap" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          "x-small": "",
                                          title: "Play",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.renewDownloadLink(
                                              recording,
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-play-circle-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          target: "_blank",
                                          icon: "",
                                          "x-small": "",
                                          title: "Download",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.renewDownloadLink(
                                              recording
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-cloud-download-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          title: "Copy URL",
                                          "x-small": "",
                                          icon: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.copyURL(
                                              _vm.recordingUrl(recording)
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-content-copy"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          title: "Delete",
                                          "x-small": "",
                                          icon: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmDeleteRecording(
                                              recording
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-close-circle"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2117296153
                ),
              })
            : _c("div", { staticClass: "text-h5 text--disabled text-center" }, [
                _vm._v("No Recordings"),
              ]),
          _c(
            "v-dialog",
            {
              attrs: { id: "video_player" },
              model: {
                value: _vm.watch_dialog,
                callback: function ($$v) {
                  _vm.watch_dialog = $$v
                },
                expression: "watch_dialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.closeVideoPlayer()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "video-container" },
                    [
                      _c(
                        "v-responsive",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { "aspect-ratio": "16/9" },
                        },
                        [
                          _vm.watch_video_url
                            ? _c("video", {
                                staticStyle: { "max-height": "70vh" },
                                attrs: {
                                  controls: "",
                                  src: _vm.watch_video_url,
                                  type: "video/webm",
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              model: {
                value: _vm.confirm_delete_recording,
                callback: function ($$v) {
                  _vm.confirm_delete_recording = $$v
                },
                expression: "confirm_delete_recording",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { width: "300" } },
                [
                  _c("v-card-text", [
                    _c("div", { staticClass: "mt-8 mx-8" }, [
                      _vm._v("Are you sure?"),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              _vm.confirm_delete_recording = null
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: { color: "red", loading: _vm.deleting },
                          on: {
                            click: function ($event) {
                              return _vm.deleteRecording()
                            },
                          },
                        },
                        [_vm._v("Delete")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }